export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-5-960-0a18b9e0d9654fa294ec78086281708e.webp";